// ⚠ BAD CODE STYLE ⚠
// Please do not use $scope ❗
// Check /docs dir for more info.
import { Captcha } from '../../../components/captcha/captcha.model';
import { SpAlert } from '../../../components/sp-alert/sp-alert.model';

/** @ngInject */
export function Controller($scope, $state, DataDeletionFormService) {

    $scope.dataDeletion = {};
    const captcha = $scope.captcha = new Captcha({isVisible: () => true});
    $scope.submit = function (form) {

        $scope.dataDeletion.captchaResponse = captcha.response;


        DataDeletionFormService.save($scope.dataDeletion).$promise.then(function (data) {
            $scope.topLevelMessage = new SpAlert('success', 'Data deletion request is sent. We will process your request and inform you with the status.');

        }, function (error) {
            if (error.status == 412) {
                const key = 'registration.company.messages.invalid_captcha';
                $scope.topLevelMessage = new SpAlert('danger', key);
            } else {
                $scope.topLevelMessage = new SpAlert('danger', error.data.message);
            }
        })
        .finally(() => captcha.reset());

        $scope.dataDeletion = {};
    }
}



// WEBPACK FOOTER //
// ./src/portal/states/public/data-deletion-form/data-deletion-form.controller.js